import { t } from '@moovly/i18n';
import * as React from 'react';
import Page from '../../../components/Page';
import LibrariesError from '../containers/LibrariesError';
import LibrariesContainer from '../containers/LibrariesContainer';
import LibraryCreateButtonContainer from '../containers/LibraryCreateButtonContainer';

const LibrariesPage = () => (
  <Page
    header="libraries"
    title={t('libraries.title')}
    error={<LibrariesError />}
    actions={
      <>
        <LibraryCreateButtonContainer />
      </>
    }
  >
    <LibrariesContainer />
  </Page>
);

export default LibrariesPage;
